import { render, staticRenderFns } from "./Avatar.vue?vue&type=template&id=581b5d76&scoped=true"
import script from "./Avatar.vue?vue&type=script&setup=true&lang=ts"
export * from "./Avatar.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./Avatar.vue?vue&type=style&index=0&id=581b5d76&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "581b5d76",
  null
  
)

export default component.exports